import { useParams, Link } from 'react-router-dom';
import { Row, Col, ListGroup, Card } from 'react-bootstrap';
import { useGetTenantDetailsQuery } from '../slices/tenantsApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Meta from '../components/Meta';
import TenantCarousel from '../components/TenantCarousel';

const TenantScreen = () => {
  const { id: tenantId } = useParams();
  const { data: tenant, isLoading, error } = useGetTenantDetailsQuery(tenantId);

  const renderTenantDetails = () => (
    <>
      <Meta title={tenant.name} description={tenant.address} />
      <Row>
        <Col md={6}>
          {tenant.images && tenant.images.length > 0 ? (
            <TenantCarousel images={tenant.images} />
          ) : (
            <Message variant="info">No images available for this tenant</Message>
          )}
        </Col>

        <Col md={3}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h3>{tenant.name}</h3>
            </ListGroup.Item>
            <ListGroup.Item>Address: {tenant.address}</ListGroup.Item>
            <ListGroup.Item>Unit Type: {tenant.type}</ListGroup.Item>
            <ListGroup.Item>Monthly Rent: {tenant.monthlyRent}</ListGroup.Item>
            <ListGroup.Item>Security Deposit: {tenant.securityDeposit}</ListGroup.Item>
            <ListGroup.Item>Status: {tenant.status}</ListGroup.Item>
            <ListGroup.Item>Contact: {tenant.contact}</ListGroup.Item>
            <ListGroup.Item>Start Date: {tenant.startDate?.substring(0, 10)}</ListGroup.Item>
          </ListGroup>
        </Col>

        <Col md={3}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <Row>
                  <Col>House:</Col>
                  <Col>{tenant.house?.name}</Col>
                  
                </Row>

              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Landlord:</Col>
                  <Col>{tenant.landlord?.name}</Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>

          <div className="tenant-images mt-3">
            <h6>Images:</h6>
            <div className="image-thumbnails">
              {tenant.images?.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Tenant ${index + 1}`}
                  className="thumbnail-img"
                  style={{
                    width: '50px',
                    height: '50px',
                    marginRight: '5px',
                    borderRadius: '5px',
                  }}
                />
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </>
  );

  return (
    <>
      <Link className="btn btn-light my-3" to="/admin/tenantlistscreen">
        Go Back
      </Link>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error?.data?.message || error.error}</Message>
      ) : (
        renderTenantDetails()
      )}
    </>
  );
};

export default TenantScreen;